export const config = {
    appScheme: "zyhealth://", // 打开app
    marketUrl: "market://details?id=",
    androidStoreUrl: `https://zy-health-keep-oss.zhi-yuan.net/pkg/android/health_latest.apk?timestamp=${Date.now()}`, // 安卓下载链接
    appStoreUrl: "https://apps.apple.com/cn/app/6751824986", // 苹果下载链接
    fallbackWebUrl: "https://health.zhi-yuan.net", // 官网链接
}

export default class Tools {
    static copy(content: any) {
        // content为要复制的内容
        // 创建元素用于复制
        const ele = document.createElement('input')
        // 设置元素内容
        ele.setAttribute('value', content)
        // 将元素插入页面进行调用
        document.body.appendChild(ele)
        // 复制内容
        ele.select()
        // 将内容复制到剪贴板
        document.execCommand('copy')
        // 删除创建元素
        document.body.removeChild(ele)
    }

    static handleAppDownload() {
        window.location.href = config.appScheme;
        Tools.copy(window.location.href);
        setTimeout(() => {
            // 如果没有安装app，没有跳转
            if (document.visibilityState === "visible") {
                if (Tools.isIOS()) {
                    window.location.href = config.appStoreUrl;
                    // 如果打开失败
                    setTimeout(() => {
                        if (document.visibilityState === "visible")
                            alert("打开应用市场失败，请您在应用市场内搜索“知源把脉养生”下载或更新哦～")
                    }, 2000)
                } else {
                    // 安卓这里不会跳转页面，直接打开下载链接
                    window.location.href = config.androidStoreUrl;
                }
            }
        }, 3000);
    }

    static isIOS() {
        const ua = typeof window === 'object' ? window.navigator.userAgent : '';

        let _isIOS = -1;
        if (_isIOS === -1) {
            _isIOS = /iPhone|iPod|iPad/i.test(ua) ? 1 : 0;
        }
        return _isIOS === 1;
    }

    static isAndroid() {
        let _isAndroid = -1;
        const ua = typeof window === 'object' ? window.navigator.userAgent : '';
        if (_isAndroid === -1) {
            _isAndroid = /Android/i.test(ua) ? 1 : 0;
        }
        return _isAndroid === 1;
    }

    static isWechat() {
        const ua = typeof window === 'object' ? window.navigator.userAgent : '';
        return !!ua.match(/MicroMessenger/i)
    }
}